import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "../../core/Dialog/Dialog";

interface IRemoveProfilePopupProps {
  open: boolean;
  onKeep: () => void;
  onRemove: () => void;
}

export const RemoveProfilePopup: FC<IRemoveProfilePopupProps> = ({
  open,
  onKeep,
  onRemove,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onKeep}
      title={t("RemoveProfile_Remove Profile")}
      description={t(
        "RemoveProfile_This profile will be removed from your account. Its data may be retained temporarily in case you need to restore it. Contact Support to request restoration.",
      )}
      mainAction={{
        text: t("RemoveProfile_Keep Profile"),
        onClick: onKeep,
        "data-gamepad": "default-selected",
      }}
      secondAction={{
        text: t("RemoveProfile_Remove Profile"),
        onClick: onRemove,
        "data-gamepad": "remove-profile-confirm",
      }}
    />
  );
};
